import React from 'react';
import { Bell, Download, Calendar, Clock, CheckCircle2, AlertTriangle, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { useTenant } from './TenantContext';

const TenantNotices = () => {
  const { dueNotices, downloading, formatCurrency, formatDate, handleDownloadDueNoticePdf, dueNoticeStatusLabels, openPayNow } = useTenant();
  return (
    <>
  <Card>
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <AlertTriangle className="w-5 h-5 text-orange-500" />
        Avis d'Échéance
      </CardTitle>
    </CardHeader>
    <CardContent>
      {dueNotices.length > 0 ? (
        <div className="space-y-3">
          {dueNotices.map((notice) => (
            <div
              key={notice.id}
              className={`p-4 rounded-lg border ${
                notice.status === 'en_retard' 
                  ? 'border-red-200 bg-red-50' 
                  : notice.status === 'paye'
                  ? 'border-green-200 bg-green-50'
                  : 'border-yellow-200 bg-yellow-50'
              }`}
              data-testid={`due-notice-${notice.id}`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-mono text-gray-500">
                    {notice.notice_number}
                  </span>
                  <Badge className={dueNoticeStatusLabels[notice.status]?.color}>
                    {dueNoticeStatusLabels[notice.status]?.label}
                  </Badge>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handleDownloadDueNoticePdf(notice.id, notice.notice_number)}
                  disabled={downloading === `notice-${notice.id}`}
                  data-testid={`download-notice-${notice.id}`}
                >
                  <Download className={`w-4 h-4 ${downloading === `notice-${notice.id}` ? 'animate-pulse' : ''}`} />
                  <span className="hidden sm:inline ml-2">PDF</span>
                </Button>
                {(notice.status === 'en_attente' || notice.status === 'en_retard') && (
                  <Button
                    size="sm"
                    onClick={() => openPayNow && openPayNow(notice.id)}
                    className="bg-[#B85C38] hover:bg-[#a04d2f] text-white ml-2"
                    data-testid={`pay-notice-${notice.id}`}
                  >
                    Payer
                  </Button>
                )}
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Montant</p>
                  <p className="text-lg font-bold text-gray-900">
                    {formatCurrency(notice.amount, notice.currency)}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Date d'échéance</p>
                  <p className={`font-medium ${notice.status === 'en_retard' ? 'text-red-600' : 'text-gray-900'}`}>
                    {formatDate(notice.due_date)}
                  </p>
                </div>
              </div>
              
              <div className="mt-2 text-sm text-gray-500">
                Période: {formatDate(notice.period_start)} - {formatDate(notice.period_end)}
              </div>
              
              {notice.description && (
                <p className="mt-2 text-sm text-gray-600 italic">
                  {notice.description}
                </p>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <AlertTriangle className="w-12 h-12 mx-auto mb-3 text-gray-300" />
          <p className="text-gray-500">Aucun avis d'échéance</p>
        </div>
      )}
    </CardContent>
  </Card>
    </>
  );
};

export default TenantNotices;
